import styled, { css } from 'styled-components';

interface CellHeaderProps {
  width?: number | string;
  minWidth: number;
  textAlign?: string;
  headerTextColor?: string;
  headerTextWeight?: string;
  headerBackgroundColor?: string;
  headerBorderColor?: string;
  headerFontSize?: string;
  isSorted?: boolean;
  height: number;
  flex?: number;
}

export const CellHeader = styled.th<CellHeaderProps>`
  height: 100%;
  flex: ${({ flex }) => flex};
  font-family: ui-sans-serif,system-ui,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  font-weight: 700;
  font-size: ${(props) => props.headerFontSize || '10px'};
  font-weight: ${(props) => props.headerTextWeight || '600'};
  padding: ${(props) => (props.headerFontSize ? '0' : '4px 0')};
  text-align: ${({ textAlign }) => textAlign || 'center'};
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  ${({
  minWidth,
  headerBackgroundColor,
  headerBorderColor,
  headerTextColor,
  height,
}) =>
    css`
      min-width: ${minWidth}px;
      background-color: ${headerBackgroundColor};
      color: ${headerTextColor};
      border: 1px solid ${headerBorderColor};
      height: ${height}px;
    `}
`;

export const ToolTip = styled.div`
  background-color: #333333;
  color: #fff;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 13px;
`;

export const FilterContainer = styled.div`
  flex: 0.3;
  font-size: 2.8rem;
  height: 2.8rem;
  width: 2.8rem;
  position: absolute;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
